import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import CardName from "../../../components/global/CardName";
import { Form } from "react-bootstrap";
import SrvButton from "../../../components/global/SrvButton";
import WidgetFile from "../../../components/card/CardFiles";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalAdd({ show, onHide, onHideTask }) {

    const [formName, setFormName] = useState(null);
    const [formMessage, setFormMessage] = useState(null);
    const [files, setFiles] = useState([]);

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);

    function addHandler() {
        setLog(null);

        if (formName === null || formName === '') {
            setLog('Введите тему обращения');
        }
        else if (formMessage === null || formMessage === '') {
            setLog('Введите текст обращения');
        }
        else {
            var formData = new FormData();
            formData.append('Name', formName);
            formData.append('Message', formMessage);

            files.map((item) => {
                formData.append('Files', item.File);
            })
            axios.post('/api_tracker/ticket/add', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                        onHide();
                        onHideTask();
                    }
                    else {
                        setLog(res.data.Error !== null ? res.data.Error : 'Неизвестная ошибка');
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка! Повторите попытку позже или обратитесь в техническую поддержку по электронной почте: support@biz-office.ru');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        <>
            <Modal show={show} onHide={onHide}  >
                <Modal.Body className="modal_min_height_350_">
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="mb-3">
                        <CardName name={formName} onlyRead={false} editingMode={true} setName={setFormName} placeholder='Тема обращения...' updateHandler={(res) => { setFormName(res) }} />
                    </div>
                    <Form.Group className="mb-3">
                        <Form.Label>Текст</Form.Label>
                        <Form.Control as="textarea" rows={5} onChange={(e) => setFormMessage(e.target.value)} />
                    </Form.Group>
                    <WidgetFile files={files} setFiles={setFiles} />
                    {log != null && (
                        <div className="form_error text-center">
                            {log}
                        </div>
                    )}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="add" size='lg' onClick={() => addHandler()} loading={loading} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}
export default ModalAdd;
